<template>
  <div class="bg-pwt_snow">
    <!-- notifications band -->
    <RequestsBand class="mt-10 mx-8"  v-if="can_see_requests"/>
    <!-- fleet logo card -->
    <FleetLogoCard class="mt-10 mx-8" />
    <!-- fleet locations list -->
    <LocationsPage location-type="fleet-fav-location" />
  </div>
</template>
<script setup lang="ts">
import LocationsPage from '@/components/location-manager/dashboard-components/LocationsPage.vue'
import type { State } from '@/store/store_types'
import { computed } from 'vue'
import { useStore } from 'vuex'
import FleetLogoCard from './FleetLogoCard.vue'
import RequestsBand from './RequestsBand.vue'

const store = useStore<State>()
const can_see_requests = computed(() =>
  store.state.permissions?.hasFieldPermission('Favourite_Location', 'update', 'approval_status'),
)
</script>
<style scoped></style>
